module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp-renew/img_webinar_07-68240b0bc52b84b7fbe995ab60d96153.png";